const FOLDER_CREATE_ERROR_I18N_KEYS = {
  FOLDER_CREATE_PARENT_DENIED:
    'com.streamlain.rootAppSidebar.organize.folder.error.create-folder-parent-denied',
  FOLDER_CREATE_RETRY_DENIED:
    'com.streamlain.rootAppSidebar.organize.folder.error.create-failed',
  FOLDER_CREATE_WORKSPACE_DENIED:
    'com.streamlain.rootAppSidebar.organize.folder.error.create-folder-workspace-denied',
} as const;

export type FolderCreateErrorI18nKey =
  | (typeof FOLDER_CREATE_ERROR_I18N_KEYS)[keyof typeof FOLDER_CREATE_ERROR_I18N_KEYS]
  | 'com.streamlain.rootAppSidebar.organize.folder.error.create-failed';

export function folderCreateErrorI18nKey(
  error: unknown
): FolderCreateErrorI18nKey {
  const code = getFolderErrorCode(error);
  if (code && code in FOLDER_CREATE_ERROR_I18N_KEYS) {
    return FOLDER_CREATE_ERROR_I18N_KEYS[
      code as keyof typeof FOLDER_CREATE_ERROR_I18N_KEYS
    ];
  }
  return 'com.streamlain.rootAppSidebar.organize.folder.error.create-failed';
}

function getFolderErrorCode(error: unknown): string | null {
  if (!error || typeof error !== 'object') return null;
  const record = error as Record<string, unknown>;
  const directCode = record.code;
  if (typeof directCode === 'string') return directCode;
  const extensions = record.extensions;
  if (extensions && typeof extensions === 'object') {
    const code = (extensions as Record<string, unknown>).code;
    if (typeof code === 'string') return code;
  }
  const graphQLErrors = record.graphQLErrors;
  if (Array.isArray(graphQLErrors)) {
    for (const graphQLError of graphQLErrors) {
      const code = getFolderErrorCode(graphQLError);
      if (code) return code;
    }
  }
  const errors = record.errors;
  if (Array.isArray(errors)) {
    for (const nestedError of errors) {
      const code = getFolderErrorCode(nestedError);
      if (code) return code;
    }
  }
  return null;
}
